/* tslint:disable */

export const BASE_URL = '/lcm/dbservice/api';
/* Schema Explorer Api */

export const ROOT_NODES_SCHEMA_URL = `${BASE_URL}/ischema/rootnodes`;

export const DELETE_ROOT_NODE_SCHEMA_URL = (vmid: string) =>
  `${BASE_URL}/ischema/rootnodes/${vmid}`;

export const GET_CHILD_NODES_SCHEMA_URL = (vmid: string) =>
  `${BASE_URL}/ischema/resources/children/${vmid}`;

export const CHILD_NODE_SCHEMA_URL = (vmid: string) =>
  `${BASE_URL}/ischema/resources/${vmid}`;

export const RESOURCES_SCHEMA_URL = `${BASE_URL}/ischema/resources`;

export const RESOURCE_SCHEMA_PROPERTY_URL = (vmid: string) =>
  `${BASE_URL}/ischema/resources/properties/${vmid}`;

export const PROPERTY_SCHEMA_URL = (vmid: string) =>
  `${BASE_URL}/ischema/properties/${vmid}`;

export const PROPERTIES_SCHEMA_URL = `${BASE_URL}/ischema/properties`;

/* Data Explorer Api */

export const ROOT_NODES_URL = `${BASE_URL}/inventory/resources/children/ROOT`;

export const CHILD_NODES_URL = (vmid: string) =>
  `${BASE_URL}/inventory/resources/children/${vmid}`;

export const RESOURCES_URL = `${BASE_URL}/inventory/resources`;

export const DELETE_NODE_URL = (vmid: string) =>
  `${BASE_URL}/inventory/resources/${vmid}`;

export const RESOURCE_PROPERTIES_URL = (vmid: string) =>
  `${BASE_URL}/inventory/resources/${vmid}/properties`;

export const PROPERTIES_URL = `${BASE_URL}/inventory/properties`;
